(function () {
  var KEY = 'wishlist_items';
  var cache = {};
  var HEART = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>';

  /* ---------- auto-load css ---------- */
  function loadCSS() {
    if (document.getElementById('wishlist-css-link')) return;
    var tag = document.querySelector('script[data-wishlist-css]');
    var href = tag && tag.getAttribute('data-wishlist-css');
    if (!href) return;
    var link = document.createElement('link');
    link.id = 'wishlist-css-link'; link.rel = 'stylesheet'; link.href = href;
    document.head.appendChild(link);
  }

  /* ---------- storage ---------- */
  function getList() {
    var raw;
    try { raw = JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { raw = []; }
    return raw.map(function (it) {
      return (typeof it === 'string') ? { handle: it, qty: 1 } : { handle: it.handle, qty: it.qty || 1 };
    });
  }
  function saveList(list) { localStorage.setItem(KEY, JSON.stringify(list)); updateCount(); updateButtons(); }
  function findIndex(list, handle) { for (var i = 0; i < list.length; i++) { if (list[i].handle === handle) return i; } return -1; }
  function toggle(handle) {
    var list = getList(), i = findIndex(list, handle);
    if (i === -1) { list.push({ handle: handle, qty: 1 }); } else { list.splice(i, 1); }
    saveList(list);
  }
  function setQty(handle, qty) {
    var list = getList(), i = findIndex(list, handle);
    if (i === -1) return;
    if (qty < 1) { list.splice(i, 1); } else { list[i].qty = qty; }
    saveList(list);
  }
  function removeItem(handle) {
    var list = getList(), i = findIndex(list, handle);
    if (i !== -1) { list.splice(i, 1); saveList(list); }
  }

  /* ---------- ui state ---------- */
  function updateCount() {
    var n = getList().length;
    document.querySelectorAll('.wishlist-count').forEach(function (el) {
      el.textContent = n; el.style.display = n > 0 ? 'inline-flex' : 'none';
    });
    document.querySelectorAll('.wl-drawer__count').forEach(function (el) { el.textContent = n; });
  }
  function updateButtons() {
    var list = getList();
    document.querySelectorAll('.wishlist-btn').forEach(function (btn) {
      var active = findIndex(list, btn.getAttribute('data-wishlist-handle')) !== -1;
      btn.classList.toggle('is-active', active);
    });
  }

  /* ---------- card hearts ---------- */
  function handleFromUrl(url) { if (!url) return null; var m = url.match(/\/products\/([^/?#]+)/); return m ? m[1] : null; }
  function injectCardButtons() {
    document.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      if (link.closest('.wl-drawer') || link.closest('#wishlist-items')) return;
      if (!link.querySelector('img')) return;
      var handle = handleFromUrl(link.getAttribute('href'));
      if (!handle) return;
      var box = link.parentElement;
      if (!box || box.querySelector('.wishlist-btn')) return;
      if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wishlist-btn wishlist-btn--card';
      btn.setAttribute('data-wishlist-handle', handle);
      btn.setAttribute('aria-label', 'Add to wishlist');
      btn.innerHTML = '<span class="wishlist-heart">' + HEART + '</span>';
      box.appendChild(btn);
    });
    updateButtons();
  }

  /* ---------- product data ---------- */
  function money(cents) { return '৳' + (cents / 100).toLocaleString('en-US'); } // change ৳ per store
  function firstVariant(p) {
    for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) return p.variants[i]; }
    return p.variants[0];
  }
  function getProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) cache[handle] = p; return p; });
  }

  /* ---------- drawer (markup is in snippets/wishlist.liquid) ---------- */
  function openDrawer() {
    var d = document.getElementById('wl-drawer'); if (!d) return;
    renderDrawer();
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var d = document.getElementById('wl-drawer'); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  function renderDrawer() {
    var d = document.getElementById('wl-drawer'); if (!d) return;
    var wrap = d.querySelector('.wl-drawer__items'), empty = d.querySelector('.wl-drawer__empty'), foot = d.querySelector('.wl-drawer__foot');
    var list = getList(); wrap.innerHTML = '';
    if (!list.length) { empty.style.display = 'flex'; foot.style.display = 'none'; updateCount(); return; }
    empty.style.display = 'none'; foot.style.display = 'block';
    var total = 0, pending = list.length;
    list.forEach(function (item) {
      getProduct(item.handle).then(function (p) {
        pending--;
        if (p) {
          var v = firstVariant(p); total += v.price * item.qty;
          var img = p.featured_image || (p.images && p.images[0]) || '';
          var row = document.createElement('div');
          row.className = 'wl-line'; row.setAttribute('data-handle', item.handle);
          row.innerHTML =
            '<a class="wl-line__media" href="' + p.url + '"><img src="' + img + '" alt="" loading="lazy"></a>' +
            '<div class="wl-line__info"><a class="wl-line__title" href="' + p.url + '">' + p.title + '</a>' +
            '<div class="wl-line__price">' + money(v.price) + '</div>' +
            '<div class="wl-line__qty"><button type="button" data-wl-dec aria-label="Decrease">−</button>' +
            '<span class="wl-line__q">' + item.qty + '</span>' +
            '<button type="button" data-wl-inc aria-label="Increase">+</button></div></div>' +
            '<button class="wl-line__remove" type="button" data-wl-remove aria-label="Remove">' +
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/></svg></button>';
          wrap.appendChild(row);
        }
        if (pending === 0) d.querySelector('.wl-drawer__total').textContent = money(total);
      });
    });
  }

  /* ---------- checkout (keeps existing cart, adds wishlist on top) ---------- */
  function goCheckout(btn) {
    var list = getList(); if (!list.length) return;
    btn.disabled = true; var old = btn.textContent; btn.textContent = 'Processing...';
    Promise.all(list.map(function (item) {
      return getProduct(item.handle).then(function (p) { return p ? { id: firstVariant(p).id, quantity: item.qty } : null; });
    })).then(function (results) {
      var items = results.filter(Boolean);
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
    }).then(function () { window.location.href = '/checkout'; })
      .catch(function () { btn.disabled = false; btn.textContent = old; alert('Something went wrong. Try again.'); });
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-wishlist-open]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-wl-close]')) { closeDrawer(); return; }
    var t = e.target.closest('.wishlist-btn');
    if (t) { e.preventDefault(); toggle(t.getAttribute('data-wishlist-handle')); var dd = document.getElementById('wl-drawer'); if (dd && dd.classList.contains('is-open')) renderDrawer(); return; }
    var line = e.target.closest('.wl-line');
    if (line) {
      var handle = line.getAttribute('data-handle'), cur = getList(), idx = findIndex(cur, handle), qty = idx !== -1 ? cur[idx].qty : 1;
      if (e.target.closest('[data-wl-inc]')) { setQty(handle, qty + 1); renderDrawer(); return; }
      if (e.target.closest('[data-wl-dec]')) { setQty(handle, qty - 1); renderDrawer(); return; }
      if (e.target.closest('[data-wl-remove]')) { removeItem(handle); renderDrawer(); return; }
    }
    if (e.target.closest('.wl-drawer__checkout')) { goCheckout(e.target.closest('.wl-drawer__checkout')); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- optional wishlist page ---------- */
  function renderWishlistPage() {
    var grid = document.getElementById('wishlist-items'); if (!grid) return;
    grid.innerHTML = '';
    getList().forEach(function (item) {
      getProduct(item.handle).then(function (p) {
        if (!p) return;
        var v = firstVariant(p), img = p.featured_image || (p.images && p.images[0]) || '';
        var card = document.createElement('div'); card.className = 'wishlist-card';
        card.innerHTML = '<a href="' + p.url + '"><img src="' + img + '" alt="" loading="lazy" style="width:100%;border-radius:8px"></a>' +
          '<a href="' + p.url + '" style="display:block;margin:8px 0 4px;color:inherit;text-decoration:none">' + p.title + '</a>' +
          '<div style="font-weight:600">' + money(v.price) + '</div>';
        grid.appendChild(card);
      });
    });
  }

  /* ---------- init ---------- */
  function init() { loadCSS(); injectCardButtons(); updateCount(); updateButtons(); renderWishlistPage(); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  var timer;
  new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(injectCardButtons, 300); }).observe(document.documentElement, { childList: true, subtree: true });
})();